"use strict";

angular.module("core")
.component("preAuthorizedPaymentAgreementButton", {
    controllerAs: "preAuthorizedPaymentAgreementButtonCtrl",
    templateUrl: require("./pre-authorized-payment-agreement-button.component.html"),
    bindings: {
        partnershipId: "<",
        agreement: "<",
        defaultEmail: "<?"
    },
    controller: function(
        $scope, ModalService, FlashBag, gettextCatalog, EmailInputModalService,
        PreAuthorizedPaymentAgreementButtonService
    ) {
        var this_ = this;
        $scope.isButtonDisabled = false;
        $scope.agreement = this.agreement;

        this.openAgreement = function() {
            // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
            ModalService.showModal({
                templateUrl: require("./modal/pre-authorizer-payment-agreement.modal.html"),
                controller: "PreAuthorizedPaymentAgreementModalController",
                controllerAs: "preAuthorizedPaymentAgreementModalCtrl",
                inputs: {
                    $attrs: {
                        agreement: this_.agreement
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function() {
                    modal.element.remove();
                });
            });
        };

        this.emailAgreement = function() {
            var inputPlaceHolder = null;
            EmailInputModalService.inputEmail(
                gettextCatalog.getString("Send pre-authorized payment agreement file by email"),
                inputPlaceHolder,
                this_.defaultEmail
            )
            .then(function onSuccess(email) {
                $scope.isButtonDisabled = true;
                PreAuthorizedPaymentAgreementButtonService.emailAgreement(this_.partnershipId, email)
                .then(function onSuccess() {
                    FlashBag.success(gettextCatalog.getString("Email was successfully sent."), true);
                }, function onError(response) {
                    FlashBag.apiError(response);
                }).finally(function() {
                    $scope.isButtonDisabled = false;
                });
            });
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/pre-authorized-payment-agreement-button/pre-authorized-payment-agreement-button.component.js
// module id = 653
// module chunks = 0